import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { chooseWXPay } from '@/lib/script/pay';

export declare namespace Deposit {
    interface Jackpot {
        total_deposit: number
        deposit: number
        level_name: string
    }
    interface ListItem {
        title: string
        created_at: string
        count: number
        balance: number
    }
}

export interface DepositState {
    jackpot: Record<string, Deposit.Jackpot>
    history: Deposit.ListItem[]
}

export const deposit: Module<DepositState, RootState> = {
    namespaced: true,
    state: {
        jackpot: {},
        history: []
    },
    mutations: {
        initHistore(state, count) {
            state.history = state.history.slice(0, count)
        },
        setHistory(state, { offset, list }: { offset: number, list: Array<Deposit.ListItem> }) {
            list.forEach((ele, key) => {
                Vue.set(state.history, offset + key, {
                    ...ele,
                    count: ele.count / 100,
                    balance: ele.balance / 100
                })
            })
        },
        setJackpot(state, {info, key}: { info: Deposit.Jackpot, key: string }) {
            // state.jackpot.deposit = option.deposit || 0
            // state.jackpot.total_deposit = option.total_deposit || 0
            Vue.set(state.jackpot, key, {
                deposit: (info.deposit || 0) / 100,
                total_deposit: (info.total_deposit || 0) / 100,
                level_name: info.level_name || '',
            })
        },
    },
    actions: {
        async getHistory(context, { offset, count, forceUpdate, activityId }: { offset: number, count: number, forceUpdate: boolean, activityId: string }) {
            if(forceUpdate) {
                this.commit('initHistore', count)
            }
            const response = await Vue.axios.get('/api/v1/deposit/detail', {
                params: {
                    offset,
                    count,
                    activity_id: activityId
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setHistory', {
                    offset, list: rdata.data
                })
            }
            return rdata;
        },
        async getInfo({commit}, { activity_id, level_id }) {
            const response = await Vue.axios.get('/api/v1/deposit/jackpot', {
                params: {
                    activity_id, level_id
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setJackpot', {
                    key: [activity_id, level_id].join('_'),
                    info: rdata.data
                })
            }
            return rdata;
        },
        async createOrder(context, {
            activity_id,
            price
        }) {
            const response = await Vue.axios.post('/api/v1/deposit/create_order', {
                activity_id, price
            });
            const rdata = response.data as {data: {type: string; order_id: number}, status: number, message: string};
            if (rdata.status !== 0) {
                return {
                    status: 'error',
                    message: rdata.message,
                };
            }
            const orderId = rdata.data.order_id
            const payResponse = await Vue.axios.post('/api/v1/participation/pay', {
                order_id: orderId,
                // type: rdata.data.type
                type: 'deposit'
            });
            const payRdata = payResponse.data;
            if (payRdata.status !== 0) {
                return {
                    status: 'error',
                    message: payRdata.message,
                };
            }

            const ret = await chooseWXPay(payRdata.data.params);
            return {
                ...ret,
                type: 'jsapi',
                orderId,
            };
        }
    }
};
